import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageView } from '../lib/ga';
import { titrePourChemin, descriptionPourChemin, estIndexable, normaliserChemin } from '../lib/titresPages';
import { poserMeta } from '../lib/metaPage';

/**
 * SuiviPages — ne rend rien. À chaque changement de route : titre de l'onglet, description,
 * adresse canonique et consigne d'indexation (lib/titresPages.js),
 * puis page vue GA4 (sans effet tant que les cookies analytiques ne sont pas acceptés).
 * À placer dans le routeur, avant CookieConsent.
 */
export default function SuiviPages() {
  const { pathname } = useLocation();

  useEffect(() => {
    const titre = titrePourChemin(pathname);
    const chemin = normaliserChemin(pathname);
    poserMeta({ titre, description: descriptionPourChemin(chemin), chemin, indexable: estIndexable(chemin) });
    gaPageView(pathname, titre);
  }, [pathname]);

  return null;
}
